import { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMessage } from "@fortawesome/pro-duotone-svg-icons";
import { useTranslation } from 'react-i18next';
import React from 'react';

function ChatStatus({ agent }) {
    const { t } = useTranslation();
    const text = agent.chats ? t("activechats") : t("hasnochats");
    const statusIcon = useMemo(() => {
        return agent.chats
            ? <FontAwesomeIcon className="px-1 text-success" size="lg" icon={faMessage} />
            : <FontAwesomeIcon className="px-1 text-muted" size="lg" icon={faMessage} />;
    }, [agent.chats]);

    return (
        <div style={{ display: "inline-block" }} title={text}>
            {statusIcon}
        </div>
    );
}

export default ChatStatus;
